enum ZipInCardStateEnum {
	default = 'default',
	loading = 'loading',
	invalidInput = 'invalidInput',
	emptyInput = 'emptyInput',
	noZipInfo = 'noZipInfo',
	submitted = 'submitted'
}

export default ZipInCardStateEnum;
